import { render, staticRenderFns } from "./BuyTypesFilter.vue?vue&type=template&id=6cfacf2d&"
import script from "./BuyTypesFilter.vue?vue&type=script&lang=js&"
export * from "./BuyTypesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports